import { all } from 'redux-saga/effects';
import { watchRestaurantSaga } from './restaurantSaga';
import { watchMenuSaga } from './menuSaga';
import { watchTpnConfigSaga } from './tpnConfigSaga';
import { watchComboSaga } from './comboSaga';
import { watchImageUploadSaga } from './imageUploadSaga';
import { watchSiteContentSaga } from './siteContentSaga';
import { watchOrderSaga } from './orderSaga';
import { watchTableAvailabilitySaga } from './tableAvailabilitySaga';
import { watchMakeReservationSaga } from './makeReservationSaga';

export default function* rootSaga() {
  yield all([
    watchRestaurantSaga(), 
    watchMenuSaga(), 
    watchTpnConfigSaga(), 
    watchComboSaga(),
    watchImageUploadSaga(),
    watchSiteContentSaga(),
    watchOrderSaga(),
    watchTableAvailabilitySaga(),
    watchMakeReservationSaga(),
  ]);
}
